import moment from "moment";
import { AddNewCard } from "./addNewCard";
import { BuyCredits } from "./buyCredits";
import { UpgradeSubscriptionModal } from "./upgradeSubscriptionModal";
import { useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { ImCreditCard } from "react-icons/im";
import { toast } from "react-toastify";
import CustomButton from "../../components/custom-button/custom-button.components";

export const Overview = () => {

      const removeCardModalRef = useRef();
      const removeCancelSubscriptionModalRef = useRef();
      const userId = useSelector((state) => state.user.userId);
      const userCredit = useSelector((state) => state.user.mycredits);
      const myCredits = useSelector(state => state.user.mycredits);
      const scheduleSettings = useSelector(
        (state) => state.user?.scheduleMeetingSettings
      );

      const [price, setPrice] = useState(0);
      const [credit, setCredit] = useState(0);
      const [paymentMethodId, setPaymentMethodId] = useState(null);

      const [subscriptionData, setSubscriptionData] = useState(null);
      const [subscriptionProgress, setSubscriptionProgress] = useState(0);

      const [addNewCardToggle, setAddNewCardToggle] = useState(false);
      const [buyCreditToggel, setBuyCreditToggel] = useState(false);

      const [saveCards, setSaveCards] = useState(null);
      const [cardSetDefault, setCardDefault] = useState(false);
  
      const claculateCredit = (e) => {
        const pricePerCredit = 0.05;
        const price = e.target.value;
        setCredit(price / pricePerCredit);
        setPrice(price);
      }

      const getAllCards = async () => {
        try {
          const headers = {
            "Content-Type": "application/json",
          };
          const response = await axios.post(
            "https://3for3networking.com/backend/wp-content/plugins/wl-api/stripe-payment/get-all-card-intent.php",
            {
              userId: userId,
            },
            { headers: headers }
          );
          if(response.data.length > 1) {
            const sortedCards = response.data.sort(
              (a, b) => (b.is_default === true) - (a.is_default === true)
            );
            setSaveCards(sortedCards);
          } else {
            setSaveCards(response.data);
          }
          if (response.data.length === 1 && !response.data[0]?.is_default) {
            setAsDefault(response.data[0]?.id);
          }

        } catch(error) {
          console.log(error)
        }
      }

      const setAsDefault = async (paymentId) => {
        try {
          const headers = {
            "Content-Type": "application/json",
          };
          const response = await axios.post(
            "https://3for3networking.com/backend/wp-content/plugins/wl-api/stripe-payment/set-card-default.php",
            {
              userId: userId,
              payment_method_id: paymentId,
            },
            { headers: headers }
          );
          setCardDefault(response.data.status === 'success' ? true : false )
        } catch (error) {
          console.log(error);
        }
      }

      const handleRemoveCard = async (e, paymentId) => {
        e.preventDefault();
        setPaymentMethodId(paymentId);        
      }

      const handleRemoveCardSubmit = async (e) => {
        e.preventDefault();
        try {
          const headers = {
            "Content-Type": "application/json",
          };
          const response = await axios.post(
            "https://3for3networking.com/backend/wp-content/plugins/wl-api/stripe-payment/remove-card-intent.php",
            {
              paymentMethodId: paymentMethodId,
            },
            { headers: headers }
          );

          if (response.data.success) {
            removeCardModalRef?.current?.click();
            getAllCards();
            toast.success(response.data.message);
          }
        } catch (error) {
          console.log(error);
        }
      }

      const handleCloseBuyCreditModal = () => {
        setBuyCreditToggel(false);
        setPrice(0);
        setCredit(0);
      }

      const calculateSubscriptionPercentage = (sDate, eDate, timeZone) => {

        // Define your start, end, and current dates in the same timezone
        const startDate = moment.tz(sDate, timeZone);
        const endDate = moment.tz(eDate, timeZone);
        const currentDate = moment.tz(timeZone); // current time in that timezone

        // Calculate time differences
        const totalDuration = endDate.diff(startDate); // total time in ms
        const timeElapsed = currentDate.diff(startDate); // elapsed time in ms

        // Calculate percentage
        let percentage = (timeElapsed / totalDuration) * 100;
        percentage = Math.max(0, Math.min(100, percentage)); // Clamp between 0–100%

        console.log(`Time Progress in ${timeZone}: ${percentage.toFixed(2)}%`);
        setSubscriptionProgress(percentage.toFixed(2));
      }

      const getActiveSubscription = async () => {
        try {
          const headers = {
            "Content-Type": "application/json",
          };
          const response = await axios.post(
            "https://3for3networking.com/backend/wp-content/plugins/wl-api/stripe-payment/get-current-subscription.php",
            {
              userId: userId,
            },
            { headers: headers }
          );
          console.log(response.data);

          if (response.data) {
            setSubscriptionData(response.data);
            calculateSubscriptionPercentage(
              response.data.start_date,
              response.data.end_date,
              scheduleSettings?.timeZone?.value
            );
          }
        } catch (error) {
          console.log(error)
        }
      }

      const handleCancelSubscriptionSubmit = async (e) => {
        e.preventDefault();
        try {
          const headers = {
            "Content-Type": "application/json",
          };
          const response = await axios.post(
            "https://3for3networking.com/backend/wp-content/plugins/wl-api/stripe-payment/cancel-current-subscription.php",
            {
              userId: userId,
            },
            { headers: headers }
          );

          if (response.status === 200) {
            removeCancelSubscriptionModalRef?.current?.click();
            toast.success(response.data.message);
            getActiveSubscription();
          }
        } catch (error) {
          console.log(error);
        }
      }

      useEffect(() => {
        getAllCards();
      }, [cardSetDefault, addNewCardToggle]);

      useEffect( () => {
        getAllCards();
        getActiveSubscription();
      }, [])

    return (
      <>
        <div className="row">
          <div className="col-12 col-sm-4 mb-3">
            <h1 className="title mb-0 mt-2">Billing</h1>
            <p>Manage your billing and credits here.</p>
          </div>

          <div className="col-12 col-sm-8 text-sm-right mb-3 mt-3">
            <div className="align-items-baseline align-items-center d-flex flex-column flex-sm-row">
              <span className="credit-remaining-text mb-0 mb-md-0 ml-sm-auto" style={{fontWeight: 500,
            color: "#3861b3"}}>
                {myCredits} Credits Remaining
              </span>
              <CustomButton
                data-toggle="modal"
                data-target="#personalInviteModal"
                className="btn btn-md btn-outline-secondary px-4 rounded-10 btn-getmorecredit ml-0 ml-sm-4 mt-2 mt-sm-0"
              >
                Get More Credits
              </CustomButton>
            </div>
          </div>

          <div className="col-12 mb-0">
            <p>
              Current Selected Plan:{" "}
              <span className="font-weight-bold text-capitalize">
                {subscriptionData?.active_plan?.replace("_plus", " +")?.replace("_", " ") ?? "Forever Free"}
              </span>
            </p>
          </div>
          <div className="col-lg-6">
            <div className="card payment-card border-dark border-2">
              <div className="card-body">
                <div className="row">
                  <div className="col-lg-4">
                    <p className="mb-1 f-14">Next Payment</p>
                    <h4 className="mb-1">
                      ${subscriptionData?.price?.toFixed(2) ?? 0}{" "}
                    </h4>
                    <p className="mb-0 f-14">
                      {subscriptionData
                        ? `On ${moment(subscriptionData.end_date)
                            .tz(scheduleSettings?.timeZone?.value)
                            .format("MMMM Do, YYYY")}`
                        : null}
                      {/* {`On ${moment().add(30, "days").format("MMMM Do, YYYY")}`} */}
                    </p>
                    {subscriptionData?.credit_balance ? (
                      <small className="text-success font-weight-bold small">
                        $
                        {parseFloat(
                          subscriptionData.credit_balance
                            .toString()
                            .replace("-", "")
                        ).toFixed(2)}{" "}
                        Credit Balance
                      </small>
                    ) : null}
                  </div>
                  <div className="col-lg-8 mt-3 mt-lg-0">
                    {saveCards?.length ? (
                      <p className="mb-1 f-14">Card Details</p>
                    ) : null}

                    {saveCards?.length
                      ? saveCards.map((card) => (
                          <div
                            className="card border-rounded mb-2"
                            key={card.id}
                          >
                            <div className="card-body py-2 px-3">
                              <div className="row align-items-center">
                                <div className="col-9 col-sm-8 col-md-9">
                                  <div className="row align-items-center">
                                    <div className="col d-inline d-sm-none d-md-inline">
                                      <ImCreditCard size={22} />
                                    </div>
                                    <div className="col-9 col-sm-12 col-md-9">
                                      <p className="mb-1 small-text f-14">
                                        **** **** **** {card.last4}
                                      </p>
                                      <p className="mb-0 small-text f-14">
                                        Exp. date{" "}
                                        {card.exp_month < 10
                                          ? `0${card.exp_month}`
                                          : card.exp_month}
                                        /{card.exp_year}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-3 col-sm-4 col-md-3 pl-0 px-sm-2 text-center d-flex flex-column">
                                  {card.is_default ? (
                                    <>
                                      <span
                                        className="btn btn-primary btn-sm rounded-10"
                                        style={{
                                          fontSize: 10,
                                          pointerEvents: "none",
                                        }}
                                      >
                                        Default
                                      </span>
                                      <p
                                        className="btn btn-sm text-danger mb-0 py-0 cursor-pointer rounded-10"
                                        style={{ fontSize: 10 }}
                                        data-toggle="modal"
                                        data-target="#removeCardModal"
                                        onClick={(e) =>
                                          handleRemoveCard(e, card.id)
                                        }
                                      >
                                        Remove
                                      </p>
                                    </>
                                  ) : (
                                    <>
                                      <button
                                        className="btn btn-primary btn-sm rounded-10"
                                        onClick={() => setAsDefault(card.id)}
                                        style={{ fontSize: 10 }}
                                      >
                                        Set Default
                                      </button>
                                      <p
                                        className="btn btn-sm text-danger mb-0 py-0 cursor-pointer rounded-10"
                                        style={{ fontSize: 10 }}
                                        data-toggle="modal"
                                        data-target="#removeCardModal"
                                        onClick={(e) =>
                                          handleRemoveCard(e, card.id)
                                        }
                                      >
                                        Remove
                                      </p>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      : null}
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 d-flex justify-content-between mt-4">
                    <div className="d-flex align-items-center">
                      <button
                        disabled={!saveCards?.length}
                        className="btn btn-primary rounded-10"
                        data-toggle="modal"
                        data-target="#upgradeSubscription"
                      >
                        <span className="f-14">Upgrade Subscription</span>
                      </button>
                      {subscriptionData?.active_plan &&
                      !subscriptionData?.subscription?.cancel_at_period_end ? (
                        <button
                          className="btn btn-outline-secondary ml-2"
                          data-toggle="modal"
                          data-target="#cancelSubscription"
                        >
                          <span className="f-14">Cancel Subscription</span>
                        </button>
                      ) : subscriptionData?.subscription.cancel_at ? (
                        <span className="ml-3 small">
                          Subscription Ends:{" "}
                          <b>
                            {moment
                              .unix(subscriptionData?.subscription.cancel_at)
                              .format("MMMM Do, YYYY")}
                          </b>
                        </span>
                      ) : null}
                    </div>

                    <button
                      className="btn btn-primary rounded-10"
                      data-toggle="modal"
                      data-target="#addNewCard"
                      onClick={() => setAddNewCardToggle(true)}
                    >
                      <span className="f-14">+ Add Card</span>
                    </button>
                  </div>

                  {subscriptionData?.start_date &&
                  subscriptionData?.end_date ? (
                    <div className="col-12">
                      <div className="form-group mt-4 mb-0">
                        <div className="d-flex justify-content-between">
                          <label for="formControlRange" className="f-14">
                            {subscriptionData
                              ? moment(subscriptionData.start_date)
                                  .tz(scheduleSettings?.timeZone?.value)
                                  .format("MMMM Do, YYYY")
                              : moment().format("MMMM Do, YYYY")}
                          </label>
                          <label for="formControlRange" className="f-14">
                            {subscriptionData
                              ? moment(subscriptionData.end_date)
                                  .tz(scheduleSettings?.timeZone?.value)
                                  .format("MMMM Do, YYYY")
                              : moment()
                                  .add(30, "days")
                                  .format("MMMM Do, YYYY")}
                          </label>
                        </div>
                        <div className="progress" style={{ height: 8 }}>
                          <div
                            className="progress-bar progress-bar-striped progress-bar-animated"
                            role="progressbar"
                            aria-valuenow={subscriptionProgress ?? 75}
                            aria-valuemin="0"
                            aria-valuemax="100"
                            style={{
                              width: `${subscriptionProgress}%` ?? "75%",
                            }}
                          ></div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6 mt-3 mt-lg-0">
            <div className="card payment-card border-dark border-2 h-100">
              <div className="card-body d-flex flex-column justify-content-between">
                <div className="row align-items-center">
                  <div className="col-lg-12">
                    <p className="mb-1 f-14">Your Credit Details</p>
                    <h4 className="mb-1">{userCredit} credits</h4>
                    <p className="mb-0 f-14">
                      Credits are used for connecting. This is a one time
                      purchase.
                    </p>
                  </div>
                  <div className="col-lg-6"></div>
                </div>

                <div className="row">
                  <div className="col-12 d-flex justify-content-between mt-4">
                    <button
                      disabled={!credit}
                      className="btn btn-primary rounded-10"
                      data-toggle="modal"
                      data-target="#buyCredits"
                      onClick={() => setBuyCreditToggel(true)}
                    >
                      <span className="f-14">Buy Credits</span>
                    </button>
                  </div>

                  <div className="col-12">
                    <div className="form-group mt-4 mb-0">
                      <div className="d-flex justify-content-between">
                        <label for="creditRange" className="f-14">
                          {credit} credits
                        </label>
                        <label for="creditRange" className="f-14">
                          ${price}.00
                        </label>
                      </div>
                      <input
                        type="range"
                        className="form-control-range"
                        id="creditRange"
                        onChange={claculateCredit}
                        max={20}
                        min={0}
                        value={price}
                      />
                    </div>
                    {/* <div className="form-group mt-4 mb-0">
                      <div className="d-flex justify-content-between">
                        <label for="formControlRange" className="f-14">
                          0 credits
                        </label>
                        <label for="formControlRange" className="f-14">
                          $0.00
                        </label>
                      </div>
                      <div className="progress" style={{ height: 8 }}>
                        <div
                          className="progress-bar progress-bar-striped progress-bar-animated"
                          role="progressbar"
                          aria-valuenow="75"
                          aria-valuemin="0"
                          aria-valuemax="100"
                          style={{ width: "75%" }}
                        ></div>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-12 mt-3 text-left">
            <div className="">
              <Link to="/terms-and-conditions" target="_blank">
                Terms and Conditions
              </Link>{" "}
              -{" "}
              <Link to="/privacy-policy" target="_blank">
                Privacy Policy
              </Link>{" "}
              -{" "}
              <Link to="/refund-policy" target="_blank">
                Refund Policy
              </Link>{" "}
              -{" "}
              <Link to="/community-guidelines" target="_blank">
                Community Guidelines
              </Link>
            </div>
          </div>
        </div>

        {/* Remove Card Confirmation Modal */}
        <div
          className="modal fade"
          id="removeCardModal"
          tabindex="-1"
          aria-labelledby="removeCardModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="removeCardModalLabel">
                  Confirmation
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to remove your card?</p>
              </div>
              <div className="modal-footer">
                <button
                  ref={removeCardModalRef}
                  type="button"
                  className="btn btn-secondary rounded-10"
                  data-dismiss="modal"
                  onClick={() => setPaymentMethodId(null)}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary rounded-10"
                  onClick={handleRemoveCardSubmit}
                >
                  Yes, Remove
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Cancel Subscription */}
        <div
          className="modal fade"
          id="cancelSubscription"
          tabindex="-1"
          aria-labelledby="cancelSubscriptionLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="cancelSubscriptionModalLabel">
                  Confirmation
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>
                  Are you sure you want to cancel your current subscription
                  plan?
                </p>
              </div>
              <div className="modal-footer">
                <button
                  ref={removeCancelSubscriptionModalRef}
                  type="button"
                  className="btn btn-secondary rounded-10"
                  data-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary rounded-10"
                  onClick={handleCancelSubscriptionSubmit}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>

        <UpgradeSubscriptionModal
          nextPaymentDate={subscriptionData?.end_date}
          setSubscriptionData={setSubscriptionData}
          currentPlan={subscriptionData?.active_plan}
        />

        {addNewCardToggle && <AddNewCard close={setAddNewCardToggle} />}

        {buyCreditToggel && (
          <BuyCredits
            credit={credit}
            price={price}
            cardSaved={saveCards?.length}
            closeModal={handleCloseBuyCreditModal}
          />
        )}
      </>
    );
}